import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import getStyles from "@/components/RenderUtils/utils/style";
import getLang from "@/components/RenderUtils/utils/lang";
import { WorkStationSettingServiceProxy } from "@/service-proxies/app-v2/workStation.service-proxies";
import { TransferDirectoryQueryServiceProxy } from "@/service-proxies/app-v2/dnc.service-proxies";
import { tranformOptionsShape } from "@/components/RenderUtils/utils/index";
import { ACLS } from "@/components/RenderUtils/utils/constants";

const service = new WorkStationSettingServiceProxy();
const directoryService = new TransferDirectoryQueryServiceProxy();

@Component
export default class TransportDirectory extends Vue {
  @Prop() workstationId!: any;

  get lang() {
    return getLang(this);
  }

  options = [];
  selectId = null;
  setting: {};

  @Watch("workstationId", { immediate: true })
  async onSelectChange(id) {
    if (!id) return;
    let data;
    try {
      data = await service.workStationTransferSettingDetail(id);
    } catch (err) {
      data = {};
    } finally {
      this.setting = data;
      this.selectId = data.transferDirectoryId || "";
    }
  }

  created() {
    this.getData();
  }

  async getData() {
    const data = await directoryService.list("0");
    const options = tranformOptionsShape("name", "id")(data);
    this.options = options;
  }

  async saveDirectory() {
    const data = {
      ...this.setting,
      transferDirectoryId: this.selectId || "",
      workStationId: this.workstationId,
    };
    // service.workStationTransferSettingDetail(this.wor)
    await service.workStationTransferSetting(data as any);
    this.$message.success(this.lang.modify_success);
  }
  filterOption(input, option) {
    return (
      option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    );
  }
  render() {
    return (
      <div style={getStyles("wrapper")}>
        <a-select
          allowClear={true}
          show-search
          filter-option={this.filterOption}
          v-model={this.selectId}
          options={this.options}
          style={getStyles("w400")}
        ></a-select>
        <a-button
          onClick={this.saveDirectory}
          type="primary"
          v-acl={ACLS.CONFIG_TRANSFER}
        >
          {this.lang.save}
        </a-button>
      </div>
    );
  }
}
